import React from 'react';
import { Trans } from 'react-i18next';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { androidExitApp, iosExitApp } from 'flow/actions/embedded-app-actions';
import Button from 'flow/components/ui-components/Button';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import EmbeddedType from 'flow/types/embedded-type';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

const SettingsOnBehalfNotifier = () => {
    const { embedded, i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const { contact } = useContact(extensionKey);

    if (!contact) {
        return null;
    }

    const onClose = () => {
        if (embedded === EmbeddedType.IOS) {
            dispatch(iosExitApp());
        } else if (embedded === EmbeddedType.ANDROID) {
            dispatch(androidExitApp());
        } else {
            history.push(
                generatePath(routes['extensions.entityKey.contact'], {
                    entityKey: extensionKey,
                }),
            );
        }
    };

    return (
        <div className="bg-yellow flex h-20 shrink-0 items-center justify-between gap-2 px-3">
            <div className="flex flex-1 items-center gap-3">
                <ContactAvatar contact={contact} />

                <p className="text-sm font-medium text-gray-800 dark:text-gray-100">
                    <Trans
                        i18n={i18next}
                        i18nKey="settings_on_behalf.banner"
                        components={[
                            <span
                                key="fullName"
                                className="font-bold text-gray-900 dark:text-gray-100"
                            >
                                {`${contact.get('firstName')} ${contact.get('lastName')}`}
                            </span>,
                        ]}
                    />
                </p>
            </div>

            <Button
                className="flex justify-end dark:!text-white"
                iconKey="close"
                color="icon"
                aria-label={i18next.t('close')}
                onClick={onClose}
            />
        </div>
    );
};

export default SettingsOnBehalfNotifier;
